import React from "react";
import "./HrdContent.css";
const HrdContent = () => {
  return (
    <div className="hrdContentContainer">
      <h2>HRD & HOME DEPARTMENT</h2>
      <p>
        Home department is headed by a principal secretary. It is an interior
        ministry mainly responsible for the maintenance of internal security and
        domestic policy. For purposes of authentication of documents, the HRD
        ministry delegated the responsibility to the respective Home Departments
        of each state after 2005. HRD attestation process is mandatory for
        higher education purposes.
      </p>
      <p>
        It is the critical initial step of certificate attestation. All the
        documents meant for attestation / apostille must be attested by the home
        department. Out of this 80% of the documents are attested by the
        Maharashtra Home Department. Otherwise known as Mantralaya. The main
        reason of this being that Mantralaya has been a point for attestation
        from the very beginning. The ease and acceptability of Mantralaya
        attestation at many embassies make it a popular choice. For Indian
        consulate attestation, the home department of the state, where the
        document originated, its attestation must be obtained and is compulsory.
      </p>
    </div>
  );
};

export default HrdContent;
